"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
const utils_1 = require("./utils");
/**
 * **DeveloperMisconfigurationError**
 *
 * ***This should NOT be used as part of a legitimate production flow***
 *
 * Where possible try to use a more specific error e.g. `MissingArgumentError`.
 * `DeveloperMisconfigurationError` is to be used in those one one off error cases
 * where none of our other errors quite make sense.
 *
 * The purpose of this class is to provide error messages to devs that something they've
 * done isn't quite right; try to make the message as specific to make debugging as
 * easy as possible!
 *
 * @param message - debug string
 * @param throwingContext - `this` of where you're throwing this error. Will be used to try and get a nice function name to provice the source class name.
 */
class DeveloperMisconfigurationError extends ExtendableError_1.default {
    constructor(message, throwingContext) {
        const throwingContextName = throwingContext && (0, utils_1.getNameFromClassInstance)(throwingContext);
        // This is an attempt to add as much information as possible to the error
        // message incase the stack strace is not returned to the developer
        // e.g. if this is returned in a HTTP response to a developer for some reason.
        const throwingContextErrorMessage = throwingContextName
            ? ` thrown by ${throwingContextName}`
            : '';
        super(`This is a @seneca developer helper error${throwingContextErrorMessage}: ${message}`);
    }
}
exports.default = DeveloperMisconfigurationError;
